import {useParams} from "react-router-dom";
import {TOURNAMENT_STATES} from "../util/Constants";
import PlayerPicker from "../components/tournaments/PlayerPicker";
import TournamentInProgress from "../components/tournaments/TournamentInProgress";
import {useTournament} from "../hooks/queries/useTournament";

function TournamentDetail() {
    const { id } = useParams()
    const { data: tournament } = useTournament(id);

    if (!tournament) return <div/>;

    return (
      <div className="base-container">
        <div className="content">
            {tournament.state === TOURNAMENT_STATES.NOT_STARTED ? <PlayerPicker tournament={tournament} /> : null}
            {tournament.state === TOURNAMENT_STATES.IN_PROGRESS || tournament.state === TOURNAMENT_STATES.FINISHED ?
              <TournamentInProgress tournament={tournament} /> : null}
        </div>
      </div>
    );
}

export default TournamentDetail
